var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('Header'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Not Found (404)")]),_c('div',[_c('p',[_vm._v("Sorry, but the page you tried to visit doesn't exist any more or never did. Please start at the "),_c('a',{attrs:{"href":"/"}},[_vm._v("home page")]),_vm._v(".")])])])
}]

export { render, staticRenderFns }